import React, { useEffect, useContext } from "react";
import { Popover, Avatar } from "antd";
import {
  MenuOutlined,
  LeftOutlined,
  RightOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { Box, Drawer, Toolbar, IconButton, Divider } from "@mui/material";

import UserProfileList from "./Users/UserProfileList";
import UserDetails from "./Users/UserDetails";
import FirstresponderDetails from "./Users/UserInfo/FirstresponderDetails";
import CaregiverDetails from "./Users/UserInfo/CaregiverDetails";

import logo from "../../../assets/images/logo.png";
import AppContext from "../../../config/AppContext";

const isMobile =
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/Windows Phone/i)
    ? true
    : false;

const drawerWidth = isMobile
  ? parseInt(document.documentElement.clientWidth)
  : parseInt(document.documentElement.clientWidth / 4);

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
}));

export default function Dashboard() {
  const theme = useTheme();
  const { showInfo, loginUserDetails, getLoginUserInfo, dologOut } =
    useContext(AppContext);
  const [open, setOpen] = React.useState(true);

  useEffect(() => {
    const userId = localStorage.getItem("loginUserId");
    if (loginUserDetails?.id === undefined) {
      getLoginUserInfo(userId);
    }
  }, [loginUserDetails]);

  const content = (
    <div onClick={() => dologOut()} style={{ cursor: "pointer" }}>
      <LogoutOutlined style={{ color: "red", fontSize: "17px" }} />
      <span style={{ color: "red", fontSize: "17px" }}> Logout</span>
    </div>
  );

  const UserDetailsView = () => {
    return (
      <div>
        {loginUserDetails?.userProfile && (
          <div>
            {loginUserDetails?.userProfile === "F" ? (
              <FirstresponderDetails />
            ) : (
              <CaregiverDetails />
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" open={open} color={"inherit"}>
        <Toolbar disableGutters>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(true)}
            edge="start"
            sx={{ ml: 2, ...(open && { display: "none" }) }}
          >
            <MenuOutlined style={{ fontSize: "30px" }} />
          </IconButton>
          <Box>
            <img
              src={logo}
              style={{
                height: "56px",
                marginTop: "5px",
              }}
              alt="Logo"
            />
          </Box>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box sx={{ flexGrow: 0, mr: 3 }}>
            <Popover content={content} trigger="hover">
              {loginUserDetails?.securedFileUrl ? (
                <Avatar size={40} src={loginUserDetails?.securedFileUrl} />
              ) : loginUserDetails?.firstName ? (
                <Avatar size={40} style={{ background: "#6a347d" }}>
                  <span style={{ fontSize: "24px" }}>
                    {loginUserDetails?.firstName?.charAt(0).toUpperCase()}
                  </span>
                </Avatar>
              ) : (
                <Avatar
                  size={40}
                  style={{ background: "#6a347d" }}
                  icon={<UserOutlined />}
                ></Avatar>
              )}
            </Popover>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={() => setOpen(false)}>
            {theme.direction === "ltr" ? <LeftOutlined /> : <RightOutlined />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <UserProfileList
          handleProfilesMenu={() => {
            setOpen(false);
          }}
          isMobile={isMobile}
        />
      </Drawer>
      <Main open={open}>
        <div style={{ marginTop: "65px" }}>
          {showInfo ? <UserDetails isMobile={isMobile} /> : <UserDetailsView />}
        </div>
      </Main>
    </Box>
  );
}
